module.exports = __webpack_public_path__ + "img/special2.ef333f66.png";